<template>
  <div
    v-show="!this.openTransferPopup"
    class="relative bg-neutral-900/80 shadow-md shadow-neutral-700 rounded-xl border border-gray-500 py-1.5 px-2 transition-all"
  >
    <button
      class="absolute top-1 right-1 text-gray-500 hover:text-gray-400 rounded-xl"
      @click="this.hiddenWallet(this.wallet)"
    >
      <tooltip text="Hide wallet">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-[18px]"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
          />
        </svg>
      </tooltip>
    </button>
    <div class="grid grid-cols-1 md:flex items-center gap-0 md:gap-2 lg:gap-4">
      <div class="text-sm flex items-center gap-2">
        <div
          v-if="this.activeEditWalletName"
          class="flex justify-center items-center gap-2 bg-neutral-800 px-1.5 py-[2px] rounded-xl border border-neutral-700"
        >
          <input
            ref="inputEditWalletName"
            class="border-none focus:ring-0 focus:outline-none p-0 bg-transparent max-w-[80px]"
            :value="this.wallet.name"
          />
          <tooltip text="Save" @click="this.submitEditWalletName">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-5 text-gray-400 hover:text-blue-500 cursor-pointer"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="m4.5 12.75 6 6 9-13.5"
              />
            </svg>
          </tooltip>
        </div>
        <tooltip text="Edit" position="right">
          <div
            v-if="!this.activeEditWalletName"
            @click="this.activeEditWalletName = true"
            class="font-bold text-gray-300"
          >
            {{ this.wallet.name }}:
          </div>
        </tooltip>
        <a
          target="_blank"
          :href="this.explorerUrlAddress(this.wallet.address)"
          class="text-sm hover:underline text-blue-500"
        >
          {{ this.shortAddress(this.wallet.address) }}
        </a>
        <tooltip text="Copy Address">
          <copy :value="this.wallet.address" />
        </tooltip>
        <tooltip text="Copy Private Key">
          <copy :value="this.wallet.privateKey">
            <template #icon>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-5 text-gray-500 hover:text-blue-500"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M15.75 5.25a3 3 0 0 1 3 3m3 0a6 6 0 0 1-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1 1 21.75 8.25Z"
                />
              </svg>
            </template>
          </copy>
        </tooltip>
        <tooltip text="Transfer">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-[22px] text-gray-500 hover:text-blue-500 cursor-pointer"
            @click="this.openTransferPopup = true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M19.5 12c0-1.232-.046-2.453-.138-3.662a4.006 4.006 0 0 0-3.7-3.7 48.678 48.678 0 0 0-7.324 0 4.006 4.006 0 0 0-3.7 3.7c-.017.22-.032.441-.046.662M19.5 12l3-3m-3 3-3-3m-12 3c0 1.232.046 2.453.138 3.662a4.006 4.006 0 0 0 3.7 3.7 48.656 48.656 0 0 0 7.324 0 4.006 4.006 0 0 0 3.7-3.7c.017-.22.032-.441.046-.662M4.5 12l3 3m-3-3-3 3"
            />
          </svg>
        </tooltip>
        <tooltip text="QR Code">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-5 text-gray-500 hover:text-blue-500 cursor-pointer"
            @click="showQRCodeWallet(this.wallet)"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M3.75 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 3.75 9.375v-4.5ZM3.75 14.625c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5a1.125 1.125 0 0 1-1.125-1.125v-4.5ZM13.5 4.875c0-.621.504-1.125 1.125-1.125h4.5c.621 0 1.125.504 1.125 1.125v4.5c0 .621-.504 1.125-1.125 1.125h-4.5A1.125 1.125 0 0 1 13.5 9.375v-4.5Z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6.75 6.75h.75v.75h-.75v-.75ZM6.75 16.5h.75v.75h-.75v-.75ZM16.5 6.75h.75v.75h-.75v-.75ZM13.5 13.5h.75v.75h-.75v-.75ZM13.5 19.5h.75v.75h-.75v-.75ZM19.5 13.5h.75v.75h-.75v-.75ZM19.5 19.5h.75v.75h-.75v-.75ZM16.5 16.5h.75v.75h-.75v-.75Z"
            />
          </svg>
        </tooltip>
      </div>
      <div class="flex items-center gap-4">
        <div class="hidden md:block w-[2px] h-[15px] bg-gray-500"></div>
        <div class="flex justify-between items-center">
          <div class="text-sm gap-1 flex items-center">
            <div class="font-bold text-red-400">
              {{ balanceFormat(this.balanceNative(this.wallet.address)) }}
            </div>
            <div>{{ this.wrappedToken }}</div>
          </div>
        </div>
        <div
          v-if="this.tokenAddress"
          class="flex justify-between items-center gap-4"
        >
          <div class="text-sm gap-1 flex items-center">
            <div
              v-if="
                (this.balanceToken(this.wallet.address) /
                  this.metadata.totalSupply) *
                  100 >=
                1
              "
              class="relative flex h-3 w-3"
            >
              <span
                class="animate-ping absolute inline-flex h-full w-full rounded-full bg-sky-400 opacity-75"
              ></span>
              <span
                class="relative inline-flex rounded-full h-3 w-3 bg-sky-500"
              ></span>
            </div>
            <div
              v-if="this.balanceToken(this.wallet.address) > 0"
              class="text-xs italic"
            >
              ({{
                (
                  (this.balanceToken(this.wallet.address) /
                    this.metadata.totalSupply) *
                  100
                ).toFixed(2)
              }}%)
            </div>
            <div class="font-bold text-red-400">
              {{ balanceFormat(this.balanceToken(this.wallet.address)) }}
            </div>
            <div class="text-sm">{{ this.metadata.symbol }}</div>
          </div>
          <div
            v-if="this.balanceToken(this.wallet.address) > 0"
            class="text-sm gap-1 flex items-center"
          >
            <div>(~</div>
            <div class="font-bold text-red-400">
              {{
                balanceFormat(
                  this.balanceToken(this.wallet.address) / this.tokenPriceInSOL
                )
              }}
            </div>
            <div>{{ this.wrappedToken }}</div>
            <div>)</div>
          </div>
        </div>
        <tooltip text="Refresh">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="w-[18px] text-gray-500 cursor-pointer hover:text-blue-500"
            :class="{
              'animate-spin text-blue-500': this.onRefresh,
            }"
            @click="this.refresh"
          >
            <path
              fill-rule="evenodd"
              d="M4.755 10.059a7.5 7.5 0 0 1 12.548-3.364l1.903 1.903h-3.183a.75.75 0 1 0 0 1.5h4.992a.75.75 0 0 0 .75-.75V4.356a.75.75 0 0 0-1.5 0v3.18l-1.9-1.9A9 9 0 0 0 3.306 9.67a.75.75 0 1 0 1.45.388Zm15.408 3.352a.75.75 0 0 0-.919.53 7.5 7.5 0 0 1-12.548 3.364l-1.902-1.903h3.183a.75.75 0 0 0 0-1.5H2.984a.75.75 0 0 0-.75.75v4.992a.75.75 0 0 0 1.5 0v-3.18l1.9 1.9a9 9 0 0 0 15.059-4.035.75.75 0 0 0-.53-.918Z"
              clip-rule="evenodd"
            />
          </svg>
        </tooltip>
      </div>
    </div>
    <div
      class="mt-1 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-2 xl:gap-4"
    >
      <div>
        <div class="flex items-center justify-between md:justify-start gap-2">
          <div class="flex gap-1 md:gap-0.5 lg:gap-2">
            <kbd
              class="text-center py-1.5 px-0.5 cursor-pointer text-[10px] w-[34px] md:w-[33px] lg:w-[35px] bg-neutral-800 text-gray-400 border shadow-md border-gray-500 rounded-xl hover:text-blue-500 hover:shadow-blue-500 hover:border-blue-500 hover:scale-105"
              v-for="(item, index) in this.options.buy"
              :key="index"
              @click="this.amountToBuy = item.value"
            >
              {{ item.name }}
            </kbd>
          </div>
          <input
            type="text"
            class="w-[80px] md:w-[75px] lg:w-[100px] text-right bg-neutral-800 border border-gray-500 text-sm rounded-xl py-1 px-2 focus:outline-none focus:ring-0"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            v-model="amountToBuy"
          />
          <button
            type="button"
            class="focus:outline-none lg:min-w-[58px] bg-neutral-800 text-gray-400 uppercase font-bold rounded-xl text-sm px-3 lg:px-3 py-1 tracking-widest"
            :disabled="this.disableBuyButton"
            :class="{
              'cursor-not-allowed shadow shadow-gray-500':
                this.disableBuyButton,
              'text-blue-500 border border-blue-500 shadow-md shadow-blue-500 hover:shadow-blue-400 hover:text-blue-400':
                !this.disableBuyButton,
            }"
            @click="this.submitBuy"
          >
            Buy
          </button>
        </div>
        <div
          v-if="this.mgs.buy"
          class="break-words text-[11px] text-yellow-500 italic"
          v-html="this.mgs.buy"
        ></div>
      </div>
      <div>
        <div class="flex items-center justify-between md:justify-start gap-2">
          <div class="flex gap-1 md:gap-0.5 lg:gap-2">
            <kbd
              class="text-center py-1.5 px-0.5 cursor-pointer text-[10px] w-[34px] md:w-[33px] lg:w-[35px] bg-neutral-800 text-gray-400 border shadow-md border-gray-500 rounded-xl hover:text-blue-500 hover:shadow-blue-500 hover:border-blue-500 hover:scale-105"
              v-for="(item, index) in this.options.sell"
              :key="index"
              @click="
                this.amountToSell =
                  (this.balanceToken(this.wallet.address) * item.value) / 100
              "
            >
              {{ item.name }}%
            </kbd>
          </div>
          <input
            type="text"
            class="w-[80px] md:w-[75px] lg:w-[100px] text-right bg-neutral-800 border border-gray-500 text-sm rounded-xl py-1 px-2 focus:outline-none focus:ring-0"
            oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1').replace(/^0[^.]/, '0');"
            v-model="amountToSell"
          />
          <button
            type="button"
            class="focus:outline-none lg:min-w-[58px] bg-neutral-800 text-gray-400 uppercase font-bold rounded-xl text-sm px-2 lg:px-3 py-1 tracking-widest"
            :disabled="this.disableSellButton"
            :class="{
              'cursor-not-allowed shadow shadow-gray-500':
                this.disableSellButton,
              'text-blue-500 shadow-md shadow-blue-500 hover:shadow-blue-700 hover:text-blue-700':
                !this.disableSellButton,
            }"
            @click="this.submitSell"
          >
            Sell
          </button>
        </div>
        <div
          v-if="this.mgs.sell"
          class="break-words text-[11px] text-yellow-500 italic"
          v-html="this.mgs.sell"
        ></div>
      </div>
    </div>
  </div>
  <transfer-popup
    v-show="this.openTransferPopup"
    :wallet="this.wallet"
    :close="this.closeTransferPopup"
    :refresh="this.refresh"
    :on-refresh="this.onRefresh"
    :submit-transfer-balance-native="this.submitTransferBalanceNative"
    :submit-transfer-balance-token="this.submitTransferBalanceToken"
  />
</template>

<script>
import Copy from "@/components/Copy.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Tooltip from "@/components/Tooltip.vue";
import TransferPopup from "@/components/TransferPopup.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Wallet",
  components: { TransferPopup, Tooltip, Copy },
  props: {
    wallet: {
      type: Object,
      required: true,
    },
    refreshWallet: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      onRefresh: false,
      openTransferPopup: false,
      amountToBuy: 0,
      amountToSell: 0,
      options: {
        buy: [
          { value: 0.1, name: 0.1 },
          { value: 0.2, name: 0.2 },
          { value: 0.5, name: 0.5 },
          { value: 1, name: 1 },
          { value: 2, name: 2 },
          { value: 3, name: 3 },
        ],
        sell: [
          { value: 10, name: 10 },
          { value: 25, name: 25 },
          { value: 30, name: 30 },
          { value: 50, name: 50 },
          { value: 75, name: 75 },
          { value: 100, name: 100 },
        ],
      },
      mgs: {
        buy: "",
        sell: "",
      },
      timeoutId: {
        buy: null,
        sell: null,
      },
      activeEditWalletName: false,
    };
  },
  watch: {
    refreshWallet() {
      if (this.refreshWallet === this.wallet.address) {
        this.refresh();
      }
    },
    "mgs.buy"() {
      if (this.timeoutId.buy) {
        clearTimeout(this.timeoutId.buy);
      }
      this.timeoutId.buy = setTimeout(() => {
        this.mgs.buy = "";
      }, 12000);
    },
    "mgs.sell"() {
      if (this.timeoutId.sell) {
        clearTimeout(this.timeoutId.sell);
      }
      this.timeoutId.sell = setTimeout(() => {
        this.mgs.sell = "";
      }, 12000);
    },
  },
  computed: {
    ...mapGetters("app", ["balanceFormat"]),
    ...mapGetters("network", [
      "wrappedToken",
      "shortAddress",
      "explorerUrlAddress",
      "explorerUrlTxn",
    ]),
    ...mapGetters("wallet", ["balanceNative", "balanceToken"]),
    ...mapState("solana", ["metadata", "tokenAddress", "tokenPriceInSOL"]),
    ...mapGetters("solana", ["getBalanceNative", "getBalanceToken"]),
    disableBuyButton() {
      return (
        this.balanceNative(this.wallet.address) <= 0 || this.amountToBuy <= 0
      );
    },
    disableSellButton() {
      return (
        this.balanceToken(this.wallet.address) <= 0 || this.amountToSell <= 0
      );
    },
  },
  methods: {
    ...mapActions("qrCodeWallet", { showQRCodeWallet: "show" }),
    ...mapActions("wallet", [
      "updateBalanceNative",
      "updateBalanceToken",
      "updateName",
      "hiddenWallet",
    ]),
    ...mapActions("solana", [
      "transferBalanceNative",
      "transferBalanceToken",
      "buy",
      "sell",
    ]),
    async refresh() {
      this.onRefresh = true;
      await this.fetchBalanceNative();
      if (this.tokenAddress) {
        await this.fetchBalanceToken();
      }
      this.onRefresh = false;
    },
    async fetchBalanceNative() {
      const address = this.wallet.address;
      const balance = await this.getBalanceNative(address);
      await this.updateBalanceNative({ address, balance });
    },
    async fetchBalanceToken() {
      const address = this.wallet.address;
      const balance = await this.getBalanceToken(address);
      await this.updateBalanceToken({ address, balance });
    },
    closeTransferPopup() {
      this.openTransferPopup = false;
    },
    async submitEditWalletName() {
      const oldName = this.wallet.name;
      const newName = this.$refs.inputEditWalletName.value;
      await this.updateName({
        address: this.wallet.address,
        name: newName,
      });
      this.$store.commit("toast/add", {
        type: "success",
        title: `${oldName} has been successfully changed to ${newName}`,
      });
      this.activeEditWalletName = false;
    },
    async submitTransferBalanceNative(recipientAddress, amount) {
      try {
        const signature = await this.transferBalanceNative({
          wallet: this.wallet,
          recipientAddress,
          amount,
        });
        this.$store.commit("toast/add", {
          type: "success",
          title: `${
            this.wallet.name
          } successfully transferred ${this.balanceFormat(amount)} ${
            this.wrappedToken
          }`,
          content: `Transaction confirmed! <a class="text-blue-500 hover:underline" target='_blank' href='${this.explorerUrlTxn(
            signature
          )}'>Txn</a>`,
        });
        await this.fetchBalanceNative();
      } catch (e) {
        this.$store.commit("toast/add", {
          type: "danger",
          title: e.message,
        });
      }
    },
    async submitTransferBalanceToken(recipientAddress, amount) {
      try {
        const signature = await this.transferBalanceToken({
          wallet: this.wallet,
          recipientAddress,
          amount,
        });
        this.$store.commit("toast/add", {
          type: "success",
          title: `${
            this.wallet.name
          } successfully transferred ${this.balanceFormat(amount)} ${
            this.wrappedToken
          }`,
          content: `Transaction confirmed! <a class="text-blue-500 hover:underline" target='_blank' href='${this.explorerUrlTxn(
            signature
          )}'>Txn</a>`,
        });
        await this.fetchBalanceToken();
      } catch (e) {
        console.log(e);
        this.$store.commit("toast/add", {
          type: "danger",
          title: e.message,
        });
      }
    },
    async submitBuy() {
      try {
        if (this.amountToBuy <= 0) {
          this.mgs.buy = `Please enter an amount of ${this.wrappedToken} to buy.`;
          return;
        }
        const balance = this.balanceNative(this.wallet.address);
        if (balance <= this.amountToBuy) {
          this.mgs.buy = `The minimum amount of ${
            this.wrappedToken
          } you can buy is ${this.balanceFormat(
            balance
          )}. Please enter a valid amount.`;
          return;
        }
        this.mgs.buy = `Buying ${this.amountToBuy} ${this.wrappedToken}...`;
        const signature = await this.buy({
          wallet: this.wallet,
          amount: this.amountToBuy,
        });
        this.mgs.buy = `Transaction confirmed! <a class="text-blue-500 hover:underline" target='_blank' href='${this.explorerUrlTxn(
          signature
        )}'>Txn</a>`;
        await this.refresh();
      } catch (e) {
        console.log(e);
        this.mgs.buy = e.message;
      }
    },
    async submitSell() {
      try {
        if (this.amountToSell <= 0) {
          this.mgs.sell = `Your wallet has zero ${this.metadata.symbol}`;
          return;
        }
        this.mgs.sell = `Selling ${this.amountToSell} ${this.metadata.symbol}...`;
        const signature = await this.sell({
          wallet: this.wallet,
          amount: this.amountToSell,
        });
        this.mgs.sell = `Transaction confirmed! <a class="text-blue-500 hover:underline" target='_blank' href='${this.explorerUrlTxn(
          signature
        )}'>Txn</a>`;
        await this.refresh();
      } catch (e) {
        console.log(e);
        this.mgs.sell = e.message;
      }
    },
  },
  async beforeMount() {},
  beforeUnmount() {
    if (this.timeoutId.buy) {
      clearTimeout(this.timeoutId.buy);
    }
    if (this.timeoutId.sell) {
      clearTimeout(this.timeoutId.sell);
    }
  },
};
</script>
